// export default {
//   BUVoucherListRealExpense
// };

const helps = [
  // #region Help

  /** Trợ giúp */
  'Help',
  /** Đăng nhập vào phần mềm */
  'Login',
  /** Tạo dữ liệu kế toán mới */
  'CreateDatabase',
  /** Chuyển đổi dữ liệu từ MISA Bamboo 2022 lên MISA Bamboo Online */
  'ConvertDatabase',
  /** Khai báo số dư ban đầu */
  'InitDefaultAmount',
  /** Hệ thống tài khoản */
  'SystemAccountList',
  /** Tài khoản kết chuyển */
  'AccountTransfer',
  /** Tài khoản ngầm định */
  'DefaultAccountList',
  /** Định khoản tự động */
  'AutoBusiness',
  /** Tính chất nguồn kinh phí */
  'BudgetSourceProperty',
  /** Nguồn kinh phí */
  'BudgetSource',
  /** Mã dự phòng */
  'BudgetProvide',
  /** Chương */
  'BudgetChapter',
  /** Loại khoản */
  'BudgetKindItem',
  /** Nhóm mục chi */
  'BudgetGroupItem',
  /** Mục/Tiểu mục */
  'BudgetItem',
  /** Phòng/ban */
  'Department',
  /** Loại cán bộ */
  'EmployeeType',
  /** Khoản lương */
  'PayrollItem',
  /** Ngạch lương */
  'SalaryScale',
  /** Quy định lương, thuế, bảo hiểm */
  'PAOption',
  /** Khách hàng/Nhà cung cấp */
  'CustomerVender',
  /** Loại khách hàng/Nhà cung cấp */
  'AccountingObject',
  /** Loại tài khoản tiềm gửi kho bạc */
  'BankInfoCategory',
  /** Tài khoản ngân hàng, kho bạc */
  'BankInfo',
  /** Cán bộ */
  'Employee',
  /** Kho */
  'Stock',
  /** Vật tư hàng hóa */
  'InventoryItem',
  /** Loại vật tư hàng hóa */
  'InventoryCategory',
  /** Công cụ dụng cụ */
  'ToolList',
  /** Loại công cụ dụng cụ */
  'ToolType',
  /** Loại tài sản cố định */
  'FixAssetType',
  /** Tài sản cố định */
  'FixAsset',
  /** Loại quỹ */
  'FundType',
  /** CTMT, Dự án */
  'Project',
  /** Phí, lệ phí */
  'Fee',
  /** Nhóm hàng hóa dịch vụ mua vào */
  'PurchasePurpose',
  /** Mẫu số hóa đơn */
  'InvoiceFormNumber',
  /** Loại chứng từ */
  'VoucherType',
  /** Nhiệm vụ */
  'Task',
  /** Hoạt động */
  'Activity',
  /** Mã thống kê */
  'Statistics',
  /** Cơ cấu vốn */
  'FundStructure',
  /** Đề tài */
  'Topic',
  /** Loại tiền */
  'Currency',
  /** Hợp đồng */
  'Contract',
  /** Tiết tiểu mục */
  'BudgetItemDetail',

  // #endregion

  // #region Kho bạc

  /** Hồ sơ thanh toán */
  'DVCFileList',
  /** Hồ sơ đối chiếu */
  'DCSDFileList',
  // #endregion

  //  #region Dự toán ngân sách

  /** Kho bạc */
  'Treasury',
  /** Nhập dự toán */
  'BUPlanImport',
  /** Nhận dự toán */
  'BUPlanReceipt',
  /** Điều chỉnh dự toán */
  'BUPlanAdjustment',
  /** Hủy dự toán */
  'BUPlanCancel',
  /** Chuyển khoản kho bạc */
  'BUTransfer',
  /** Chuyển khoản kho bạc bằng TK tiền gửi */
  'BUTransferDeposit',
  /** Nhập cam kết chi ban đầu */
  'BUOpeningCommitment',
  /** Đề nghị cam kết chi */
  'BUCommitmentRequest',
  /** Điều chỉnh cam kết chi */
  'BUCommitmentAdjustment',
  /** Rút dự toán tạm ứng đã cấp bằng tiền mặt */
  'CAPlanWithDraw',
  /** Rút dự toán tạm ứng đã cấp dự toán bằng tiền gửi */
  'BUPlanWithDraw',
  /** Rút dự toán tạm ứng đã cấp bằng chuyển khoản kho bạc */
  'BUPlanWithDrawTransfer',
  /** Rút dự toán tạm ứng chưa cấp bằng tiền mặt */
  'CAPlanWithDrawNotPlaned',
  /** Rút dự toán tạm ứng chưa cấp dự toán bằng tiền gửi */
  'BUPlanWithDrawNotPlaned',
  /** Rút dự toán tạm ứng chưa cấp bằng chuyển khoản kho bạc */
  'BUPlanWithDrawTransferNotPlaned',
  /** Rút dự toán thực chi bằng tiền mặt */
  'CAPlanWithDrawRealExpense',
  /** Rút dự toán thực chi bằng tiền gửi */
  'BUPlanWithDrawRealExpense',
  /** Rút dự toán thực chi bằng chuyển khoản kho bạc */
  'BUPlanWithDrawTransferRealExpense',
  /** Rút dự toán chuyển khoản lương, bảo hiểm */
  'BUPlanWithDrawTransferPAOption',
  /** Điều chỉnh kinh phí */
  'BUPlanWDAdjustment',
  /** Dự toán giữ lại */
  'BUBudgetReserve',
  /** Bảng kê chứng từ thanh toán đã cấp dự toán */
  'BUVoucherList',
  /** Bảng kê chứng từ thanh toán chưa cấp dự toán */
  'BUVoucherListNotPlaned',
  /** Bảng kê chứng từ ghi thu ghi chi */
  'BUVoucherListReceiptExpense',
  /** Lập bảng kê chứng từ thanh toán thực chi */
  'BUVoucherListRealExpense',
  /** Bảng kê khác */
  'BUVoucherListOther',
  /** Tổng hợp dự toán */
  'BUPlanSummary',
  /** Bảng kê thanh toán tạm ứng */
  'BUAdvancePayment',
  /** Bảng kê chứng từ thực chi */
  'BUAdvanceExpence',
  /** Bảng kê Ghi thu Ghi chi */
  'BUExpenseReceipt',
  // Kế hoạch vốn đầu tư XDCB
  'BUInvestmentPlanXDCB',
  /** Kế hoạch thu chi các hoạt động tài chính khác */
  'BUFinancialActivities',

  // #endregion

  // #region Kế toán tiền mặt

  /** Tiền mặt */
  'Cash',
  /** Phiếu thu */
  'CAReceipt',
  /** Rút tiền gửi NHKB nhập quỹ tiền mặt */
  'CAReceiptWithDraw',
  /** Nhận các khoản kinh phí bằng tiền mặt */
  'CAReceiptPlanWithDraw',
  /** Chi tiền mặt nộp vào tài khoản ngân hàng */
  'CAPaymentDeposit',
  /** Phiếu chi */
  'CAPayment',
  /** Điều chỉnh kinh phí thu */
  'CAAdjustReceipt',
  /** Điều chỉnh kinh phí chi */
  'CAAdjustPayment',
  /** Bảng kê nộp tiền NSNN */
  'BAAdvanceNSNN',
  /** Kiểm kê quỹ tiền mặt */
  'CAFundInventory',

  // #endregion

  // #region Kế toán tiền gửi

  /** Tiền gửi */
  'Deposits',
  /** Thu tiền gửi */
  'BADeposit',
  /** Chi tiền gửi */
  'BAWithDraw',
  /** Chuyển tiền nội bộ */
  'BABankTransfer',

  // #endregion

  // #region Kế toán Tài sản cố định

  /** Tài sản cố định */
  'Asset',
  /** Danh sách TSCĐ */
  'FixedAssetVoucher',
  /** Mua sắm TSCĐ */
  'BUTransferFixedAsset',
  /** Chi mua tài sản cố định bằng tiền mặt */
  'CAPaymentFixedAsset',
  /** Chi mua tài sản cố định bằng tiền gửi */
  'BAWitdDrawFixedAsset',
  /** Ghi tăng TSCĐ */
  'VoucherIncrement',
  /** Ghi giảm TSCĐ */
  'VoucherDecrement',
  /** Đánh giá lại TSCĐ */
  'VoucherAdjustment',
  /** Điều chuyển TSCĐ */
  'FATransfer',
  /** Trích khấu hao tài sản cố định */
  'VoucherDepreciate',
  /** Tính hao mòn tài sản cố định */
  'VoucherDepreciation',
  /** Ghi tăng QLTS */
  'FAVoucherIncrement',
  /** Ghi giảm QLTS */
  'FAVoucherDecrement',
  /** Đánh giá lại QLTS */
  'FAVoucherAdjustment',
  /** Trích khấu hao QLTS */
  'FAVoucherDepreciate',
  /** Tính hao mòn QLTS */
  'FAVoucherDepreciation',
  /** Bán TSCĐ */
  'FARevenue',
  /** Mua và ghi tăng */
  'VoucherPurchaseIncrement',
  // #endregion

  // #region Kế toán công cụ dụng cụ

  /** Công cụ dụng cụ */
  'Tools',
  /** Ghi tăng CCDC */
  'SUIncrement',
  /** Điều chuyển công cụ dụng cụ */
  'SUTransfer',
  /** Sổ CCDC */
  'SUBook',
  /** Ghi giảm CCDC */
  'SUDecrement',

  // #endregion

  // #region Kế toán vật tư hàng hóa

  /** Kế toán vật tư hàng hóa */
  'Inventory',
  /** Nhập mua bằng tiền mặt */
  'PUPaymentDetail',
  /** Nhập mua chưa thanh toán */
  'PUInvoiceDetail',
  /** Nhập khác */
  'INInward',
  /** Xuất kho */
  'INOutward',
  /** Điều chỉnh tồn kho */
  'INAjustment',
  /** Chuyển kho */
  'INTransfer',
  /** Tính giá xuất kho */
  'CalcInOutward',
  /** Báo cáo tồn kho */
  'INReport',

  // #endregion

  // #region Kế toán hóa đơn

  /** Hóa đơn điện tử  */
  'Invoice',
  /** Màn hình danh sách Hóa đơn  */
  'InvoiceList',
  /** Lập hóa đơn */
  'CreateInvoice',

  // #endregion

  // #region Hóa đơn điện tử

  /** Hóa đơn điện tử */
  'InvoiceConnect',
  /** Màn hình danh sách Hóa đơn điện tử */
  'SaleInvoice',
  /** Thiết lập kết nối phần mềm Hóa đơn điện tử meInvoice */
  'InvoiceConnect',
  /** Khởi tạo mẫu hóa đơn điện tử (meInvoice) */
  'InvoiceCreate',
  /** Thiết lập chữ ký số */
  'InvoiceSetup',
  /** Thiết lập Email gửi hóa đơn */
  'InvoiceEmail',
  /** Hoàn thiện tờ khai (meInvoice) */
  'InvoiceComplete',
  /** Lập hóa đơn điện tử */
  'SASaleInvoiceDetail',
  /** Phát hành hóa đơn điện tử */
  'InvoiceRelease',
  /** Gửi hóa đơn cho khách hàng */
  'InvoiceSend',
  /** Hủy hóa đơn */
  'InvoiceCancel',
  /** Lập hóa đơn thay thế */
  'InvoiceReplace',
  /** Lập hóa đơn điều chỉnh */
  'InvoiceAdjustment',

  // #endregion

  // #region Kế toán tiền lương

  /** Kế toán tiền lương */
  'Salary',
  /** Tổng hợp ngày nghỉ/làm thêm */
  'StatisticalDayOff',
  /** Tổng hợp thu nhập không thường xuyên */
  'OtherIncome',
  /** Khấu trừ không thường xuyên */
  'PAOtherOutcome',
  /** Truy lĩnh nâng lương */
  'PARetroSalaryIncrease',
  /** Truy lĩnh nâng lương tối thiểu */
  'PARetroStandardSalaryIncrease',
  /** Tính lương, bảo hiểm, thuế thu nhập cá nhân */
  'Salary',
  /** Hạch toán chi phí lương, bảo hiểm, KPCĐ */
  'SalaryKPCD',
  /** Trả lương, bảo hiểm (Trường hợp kết nối SalaGov) */
  'SalaryPayrollSalagov',
  /** Trả lương */
  'PAPaySalaryGenData',
  /** Nộp thuế TNCN */
  'PAPayTax',
  /** Trả lương cho cán bộ nợ lương từ năm trước */
  'SalaryLastYear',
  /** Kết nối với phần mềm Tính lương MISA SalaGov */
  'SalarySalaGov',

  // #endregion

  // #region Kế toán mua hàng

  /** Kế toán mua hàng */
  'Purchase',
  /** Mua hàng trả tiền ngay */
  'PUPayment',
  /** Mua hàng chưa thanh toán */
  'PUInvoice',
  /** Trả tiền nhà cung cấp */
  'PUVendor',

  // #endregion

  // #region Bán hàng

  /** Bán hàng */
  'Sell',
  /** Bán hàng thu tiền ngay */
  'CAReceiptSale',
  /** Bán hàng chưa thu tiền */
  'SAInvoice',
  /** Thu tiền khách hàng */
  'CAReceiptCustomer',
  /** Hàng bán trả lại */
  'SAReturn',

  // #endregion

  // #region Kế toán thuế

  /** Kế toán thuế */
  'Tax',
  /** Lập bảng kê mua vào */
  'TaxVoucherBuy',
  /** Lập bảng kê bán ra */
  'TaxVoucherSale',
  /** Khấu trừ thuế */
  'TaxVoucherDeduct',
  /** Tờ khai thuế */
  'TaxCreate',
  /** Nộp thuế */
  'TaxSubmit',

  // #endregion

  // #region Tổng hợp

  /** Tổng hợp */
  'Summary',
  /** Chứng từ nghiệp vụ khác */
  'GLVoucher',
  /** Lập bảng tổng hợp chứng từ cùng loại */
  'VoucherSummaryTable',
  /** Lập chứng từ ghi sổ */
  'GLPostedVoucher',
  /** Sổ cái */
  'SummaryBook',
  /** Tạm tính thuế thu nhập doanh nghiệp */
  'ProvisionalTaxInCome',
  /** Quyết toán thuế thu nhập doanh nghiệp */
  'FinalTaxInComeEnterprise',
  /** Tiền chuyển đến */
  'BATransferDeposit',
  /** Tiền chuyển đi */
  'BATransferWithdraw',
  /** Xác định kết quả hoạt động */
  'GLProfitLossTransfer',
  /** Kết chuyển số dư cuối năm */
  'EndYearTransfer',
  /** Khóa sổ kế toán */
  'NotPostedCloseBook',
  /** Báo cáo tài chính */
  'CRERepList',
  /** Báo cáo quyết toán */
  'CRERepSettleMent',
  /** Nộp báo cáo cho kho bạc */
  'CRERepExportList',
  /** Nộp báo cáo cho cấp trên */
  'CRERepSubmit',
  /** Nộp báo cáo cho cơ quan thuế */
  'CRERepexportListTax',
  /** Quyết toán số dư đầu năm */
  'BeginningYearTransfer',
  /** Phiếu kết chuyển/Quyết toán */
  'SUAccountTransfer',
  /** Nộp báo cáo tài chính lên cấp trên */
  'SUSubmitReport',

  // #endregion

  // #region Tiện ích

  /** Nhập số dư ban đầu */
  'OPAccountBalance',
  /** Danh mục */
  'Dictionary',
  /** Thiết lập quy tắc hạch toán đồng thời */
  'AccountParallelRule',
  /** Báo cáo tài chính */
  'ChooseFinanceReportSetting',
  /** Tùy chọn */
  'CustomSetting',
  /** Sắp xếp lại số chứng từ */
  'SortRefno',
  /** Khóa sổ/Bỏ khóa sổ kỳ kế toán */
  'CloseBook',
  /** Ghi sổ/Bỏ ghi sổ theo lô */
  'LedgerVoucher',
  /** Chế độ ghi sổ */
  'PostMode',
  /** Xuất khẩu báo cáo */
  'ExportReport',
  /** Xuất khẩu dữ liệu */
  'Export',
  /** Nhận mẫu báo cáo */
  'ReportReceive',
  /** Tùy chỉnh mẫu */
  'CustomReport',
  /** Kết xuất dữ liệu – Kết nối KBNN */
  'ExportDVC',
  /** Bảo trì dữ liệu */
  'MainTain',
  /** Sao chép phần mềm */
  'Copy',
  /** Cập nhật thông tin */
  'LiveUpdate',
  /** Máy in */
  'Print',
  /** Thông tin đơn vị */
  'OrganizationInfo',
  /** Quản lý người dùng */
  'User',
  /** Quản lý dữ liệu */
  'Data',
  /** Vai trò quyền hạn */
  'Role',
  /** Tính năng bổ sung */
  'AdditionalFeature',
  /** Thiết lập ngầm định */
  'DefaultImplicitSetting',
  /** Ẩn hiện cột */
  'HideShowColumn',
  /** Báo cáo nhanh */
  'QuickReport',
  /** Nhật ký truy cập */
  'AccessHistory',

  /**
   * Báo cáo S05H
   */
  'S05H',

  // báo cáo b08. b09, b114, b115, b117, b118, B02bx_VT
  'TT3442016_B08',
  'TT3442016_B09',
  'TT3432016_B114',
  'TT3432016_B115',
  'TT3432016_B117',
  'TT3432016_B118',
  'ReportB02bX_VuThu',

  // #endregion

  // #region video

  'Introduction',

  // #endregion
  /**
   * Xuất khẩu XML
   */
  'CRERepExportXML',
  /**
   * Các màn hình quy trình
   */
  'ProcessCCDC',
  'ProcessKBDT',
  'ProcessTM',
  'ProcessTG',
  'ProcessOther',
  'ProcessDTNS',
  'ProcessTSCD',
  'ProcessSalary',

  'ProtectAdvance', //Bảo mật nâng cao
  'NumberFormat', //Định dạng số
  'ConnectMisa', //Kết nối phần mềm MISA
  'InitialInfomation', //Khai báo thông tin ban đầu
  'PrintReportSetting', //Thiết lập báo cáo in
  'EsignSetting', //Thiết lập chữ ký số
  'ThemeColor', //Tùy chỉnh màu sắc giao diện
  'Search', //Tìm kiếm

  //#region Hướng dẫn quyết toán
  'SettlementInstructionsPaymentAdvance',
  'SettlementInstructionsPaymentReceipExpense',
  'CashDepositReconciliation_111',
  'CashDepositReconciliation_112',
  'SettlementInstructionsBy431Account',
  'SettlementInstructionsTreasuryCompare', //Báo cáo đối chiếu kho bạc
  'SalaryVoucherListSettlementInstructions',
  'SettlementInstructionsAccountTransfer', //HDQT kết chuyển
  'SettlementInstructionDataReconciliation',
  'AuditAdvancePaymentVoucher',
  'ExpenseComparisonByMLNS', // Đối chiếu số liệu chi theo MLNS
  'ReceiptComparisonByMLNS', // Đối chiếu số liệu thu theo MLNS
  'Formula07Check', // Kiểm tra công thức 07
  'Formula08Check', // Kiểm tra công thức 08
  'Formula09Check', // Kiểm tra công thức 09
  'Formula60Check', // Kiểm tra công thức 60
  'Comparison6162Check', // Kiểm tra đối chiếu 61, 62
  'SettlementInstructionsBy336Account',
  'SettlementInstructionDataReconciliationUpdated',
  'VoucherNotReferInstructions',
  'UnaccountedTreasuryInstructions',
  'SettlementInstructionMain', //hdsd
  'GenAndSubmitDocToDvc', // knowledge-base/lap-ho-so-doi-chieu-kho-bac-gui-truc-tiep-len-dvc-kbnn/
  'HowToSubmitReport20', // knowledge-base/lam-the-nao-de-nop-duoc-bao-cao-doi-chieu-kho-bac-mau-so-20a-mau-so-20c-truc-tiep-tu-phan-mem-len-he-thong-dvc/
  'TreasuryComparisonReport', // knowledge-base/bao-cao-doi-chieu-kho-bac/

  // #region Câu hỏi thường gặp

  /** Dự toán ngân sách */
  'BudgetPlanDTNS', //Dự toán ngân sách
  'BudgetPlanBCDC', //Báo cáo đối chiếu kho bạc
  'BudgetPlanBCNSX', //Báo cáo ngân sách xã

  /** Câu hỏi về tiền mặt */
  'CashBalanceNegativeQuestion', // Khi cất chứng từ phần mềm báo "Số dư của tài khoản 111x ...xuất quỹ tiền âm không?" thì làm thế nào?
  'S11HNegativeBalance', // Khi in Mẫu số S11-H: Sổ quỹ tiền mặt, số tồn bị âm hoặc bị sai thì làm thế nào?
  'S11HSelectFund', // Làm thế nào khi in Mẫu số S11-H: Sổ quỹ tiền mặt không chọn được Quỹ tiền?

  /** Câu hỏi về tiền gửi */
  'DepositBalanceNegativeQuestion', // Khi cất chứng từ chi tiền gửi phần mềm báo "Số dư của tài khoản 1121...xuất quỹ tiền âm" thì làm thế nào?
  'S03XNegativeSalaryAccount', // Xem sổ S03-X: Sổ tiền gửi kho bạc của Tài khoản ngân hàng để trả lương bị âm thì làm thế nào?
  'S03XInconsistencyTreasury', // Khi in Mẫu sổ S03-X: Sổ tiền gửi kho bạc không khớp với số liệu thực tế tại kho bạc thì làm như thế nào?

  /** Câu hỏi về tài sản cố định */
  'FixedAssetConnect', // Kết nối/không kết nối MISA QLTS

  /** Câu hỏi về tổng hợp */
  'SettlementCompletionSteps', // Các bước hoàn thành quyết toán
  'BalanceSheetFinancialReportIssues', // Các vấn đề thường gặp ở bảng cân đối tài khoản và báo cáo tài chính

  // #endregion
];

export default helps.reduce((obj, x) => ({...obj, [x]: x}), {});
